document.addEventListener("DOMContentLoaded", function () {
  function updateCallOuts() {
    const lastVariantAdded = window.localStorage.getItem("lastVariantAdded");
    const cartItemCallOut = document.querySelector(
      `[data-call-out="${lastVariantAdded}"]`
    );
    if (cartItemCallOut) cartItemCallOut.classList.remove("hidden");
  }
  document.addEventListener("cart:update", () => {
    updateCallOuts();
  });

  updateCallOuts();

  /**
   * Selleasy carousels (PDP cpac + cart drawer upsell):
   * The widget's nav arrows are visible (restyled to match the theme's native
   * slideshow arrows in od-custom.css). This adds press-and-hold on the track
   * as a second way to page through — dragging the track directly fights the
   * widget's internal scroll-snap JS (every manual scrollLeft write gets
   * overridden mid-drag, so it never feels smooth).
   *
   * Instead: press-and-hold the left or right half of the track to repeatedly
   * click the widget's own nav button — reuses its native smooth scroll/snap
   * animation, so motion stays smooth and correct. Clicks that land on an
   * arrow are ignored here so the arrow's own click handling takes over.
   */
  (function enableSelleasyHoldToScroll() {
    var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
    // Left half = scroll back, right half = scroll forward. If that direction's
    // nav is disabled (e.g. back at scroll 0), fall back to the other button so
    // the first card and last slide still respond to a hold.
    var HOLD_START_MS = 220; // must stay pressed this long before the first scroll fires
    var REPEAT_INTERVAL_MS = 320; // repeat rate once actively holding

    var holdStartTimeout = null;
    var holdInterval = null;
    var activeButton = null;
    // Mousedown on cart-drawer upsell track + mouseup on backdrop fires a "click"
    // that dialog.js treats as outside → drawer closes. Suppress only that case.
    var suppressDrawerDismissClick = false;

    function clearHold() {
      clearTimeout(holdStartTimeout);
      clearInterval(holdInterval);
      holdStartTimeout = null;
      holdInterval = null;
      activeButton = null;
    }

    function isNavEnabled(button) {
      if (!button) return false;
      if (button.classList.contains('lb-nav-disable')) return false;
      // Cart drawer upsell uses lb-nav-hide at start/end instead of lb-nav-disable
      if (button.classList.contains('lb-nav-hide')) return false;
      return true;
    }

    function clickIfEnabled(button) {
      if (!isNavEnabled(button)) {
        clearHold();
        return;
      }
      button.click();
    }

    /**
     * Arm a potential hold — does nothing until the mouse stays down past
     * HOLD_START_MS. A normal quick click never triggers a scroll or
     * preventDefault, so regular clicks on cards keep working.
     */
    function startHold(button) {
      clearHold();
      activeButton = button;

      holdStartTimeout = setTimeout(function () {
        clickIfEnabled(activeButton);
        holdInterval = setInterval(function () {
          clickIfEnabled(activeButton);
        }, REPEAT_INTERVAL_MS);
      }, HOLD_START_MS);
    }

    function getNavButtons(scrollContainer) {
      var cont = scrollContainer.closest('.lb-carousel-cont') || scrollContainer.parentElement;
      if (!cont) return null;
      return {
        left: cont.querySelector('.lb-carousel-left-svg'),
        right: cont.querySelector('.lb-carousel-right-svg'),
      };
    }

    function pickNavButton(buttons, ratio) {
      var wantLeft = ratio < 0.5;
      var leftEnabled = isNavEnabled(buttons.left);
      var rightEnabled = isNavEnabled(buttons.right);

      if (wantLeft) {
        if (leftEnabled) return buttons.left;
        if (rightEnabled) return buttons.right;
      } else {
        if (rightEnabled) return buttons.right;
        if (leftEnabled) return buttons.left;
      }
      return null;
    }

    function bindHold(scrollContainer) {
      if (!scrollContainer || scrollContainer.dataset.hpHoldBound === 'true') return;
      scrollContainer.dataset.hpHoldBound = 'true';

      scrollContainer.addEventListener('mousedown', function (event) {
        if (!DESKTOP_MQ.matches) return;
        if (event.button !== 0) return;
        if (
          event.target.closest(
            'button, select, input, label, a.lb-button, .lb-button, .lb-variant-picker, ' +
              '.lb-carousel-nav, .lb-carousel-left-svg, .lb-carousel-right-svg'
          )
        ) {
          return;
        }

        if (scrollContainer.closest('.cart-drawer__content')) {
          suppressDrawerDismissClick = true;
        }

        var buttons = getNavButtons(scrollContainer);
        if (!buttons) return;

        var rect = scrollContainer.getBoundingClientRect();
        var ratio = (event.clientX - rect.left) / rect.width;
        var button = pickNavButton(buttons, ratio);
        if (!button) return;

        event.preventDefault();
        startHold(button);
      });

      scrollContainer.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
    }

    window.addEventListener('mouseup', clearHold);
    window.addEventListener('mouseleave', clearHold);
    window.addEventListener('blur', clearHold);

    document.addEventListener(
      'click',
      function (event) {
        if (!suppressDrawerDismissClick) return;

        var drawer = document.getElementById('hp-cart-drawer');
        var dialog = drawer && drawer.querySelector('dialog');
        suppressDrawerDismissClick = false;

        if (!dialog || !dialog.open) return;

        var releasedOnBackdrop =
          event.target instanceof HTMLDialogElement || !dialog.contains(event.target);

        if (releasedOnBackdrop) {
          event.stopPropagation();
        }
      },
      true
    );

    var CAROUSEL_TRACK_SELECTOR =
      '.lb-widget-cpac .lb-carousel-products, .cart-drawer__content lb-upsell-widget .lb-carousel-products';

    function bindAll() {
      document.querySelectorAll(CAROUSEL_TRACK_SELECTOR).forEach(bindHold);
    }

    bindAll();

    var observer = new MutationObserver(bindAll);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();

  // Afterpay/Square messaging update on variant change
  document.addEventListener("variant:update", function (event) {
    const variant = event.detail?.resource;
    const newHtml = event.detail?.data?.html;
    
    if (!variant || variant.price === undefined) return;

    // Method 1: Replace Afterpay elements from server response HTML
    // This ensures the Afterpay app block renders with the correct variant price
    if (newHtml) {
      const newAfterPayElements = newHtml.querySelectorAll(
        "afterpay-placement, square-placement, [data-afterpay-placement], [data-square-placement]"
      );
      
      newAfterPayElements.forEach((newElement) => {
        // Find matching element in current DOM and replace it
        const selector = newElement.tagName.toLowerCase();
        const currentElements = document.querySelectorAll(selector);
        
        currentElements.forEach((currentElement) => {
          // Replace the current element with the new one from the response
          if (currentElement.parentNode) {
            currentElement.parentNode.replaceChild(
              newElement.cloneNode(true),
              currentElement
            );
          }
        });
      });
    }

    // Method 2: Also update data-amount directly as a fallback
    const placements = document.querySelectorAll(
      "afterpay-placement, square-placement, [data-afterpay-placement], [data-square-placement]"
    );
    
    placements.forEach((placement) => {
      // Shopify variant.price is in cents (e.g., 3895 for $38.95)
      // Afterpay expects amount in dollars with cents (e.g., "38.95")
      // Convert from cents to dollars
      const priceInDollars = (variant.price / 100).toFixed(2);
      
      if (placement.getAttribute("data-amount") !== priceInDollars) {
        placement.setAttribute("data-amount", priceInDollars);
      }
    });

    // Method 3: Trigger refresh APIs if available
    requestAnimationFrame(() => {
      if (window.Square?.Payments?.Afterpay?.refresh) {
        window.Square.Payments.Afterpay.refresh();
      } else if (window.Afterpay?.refresh) {
        window.Afterpay.refresh();
      }
      
      // Dispatch custom event for any listeners
      document.dispatchEvent(new CustomEvent("afterpay:refresh", { 
        detail: { amount: variant.price / 100 } 
      }));
    });
  });
});
